module.exports = __webpack_public_path__ + "c5ee10998dcb1f9b1668500bb8604db6.png";